import { Component, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'app-report-viewer',
  host: {
    class: 'flex-grow-1'
  },
  templateUrl: './report-viewer.component.html',
  styleUrls: ['./report-viewer.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ReportViewerComponent {
  reportFilePath = '1 - Factoring/AFI_NoBuyBrokers.trdp';
  params: Array<any> = [];

  showReport = true;
}



// WEBPACK FOOTER //
// ./src/app/developer/reporting/report-viewer/report-viewer.component.ts